export const escapeRegExp = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

function buildWordMatcher(words) {
  const escaped = words.map(escapeRegExp).join('|');
  try {
    return {
      rx: new RegExp(`(?<!\\p{L})(?:${escaped})(?!\\p{L})`, 'giu'),
      hasPrefixCapture: false,
    };
  } catch {
    try {
      return {
        rx: new RegExp(`(^|[^\\p{L}])(?:${escaped})(?=[^\\p{L}]|$)`, 'giu'),
        hasPrefixCapture: true,
      };
    } catch {
      return {
        rx: new RegExp(`\\b(?:${escaped})\\b`, 'gi'),
        hasPrefixCapture: false,
      };
    }
  }
}

export const maskWords = (text, wordList, replacement = '***') => {
  if (typeof text !== 'string' || !Array.isArray(wordList) || wordList.length === 0) return text;

  const { rx, hasPrefixCapture } = buildWordMatcher(wordList);

  if (hasPrefixCapture) {
    // Ghép lại ký tự biên trái đã bắt được (nhóm 1)
    return text.replace(rx, (_m, left) => (left || '') + replacement);
  }
  // Trường hợp có lookbehind hoặc fallback ASCII: thay trực tiếp
  return text.replace(rx, replacement);
};

export const getMaskWordsFromEnv = (envVar) => {
  if (typeof envVar !== 'string' || !envVar.trim()) return [];
  return envVar.split(',').map(s => s.trim()).filter(Boolean);
};

export const maskText = (text, replacement = '***') => {
  const maskEnv = process.env.REACT_APP_STRING_MASK || '';
  const words = getMaskWordsFromEnv(maskEnv);
  return maskWords(text, words, replacement);
};
